import { SVGProps } from 'react';

export default function Youtube({
  ...props
}: SVGProps<SVGSVGElement> & { color: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      style={{ color: props.color }}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 0C6.939 0 0 6.939 0 15.5C0 24.061 6.939 31 15.5 31C24.061 31 31 24.061 31 15.5C31 6.939 24.061 0 15.5 0ZM15.5 1C23.495 1 30 7.505 30 15.5C30 23.495 23.495 30 15.5 30C7.505 30 1 23.495 1 15.5C1 7.505 7.505 1 15.5 1Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7998 18.0498V12.9498L18.2168 15.4998L13.7998 18.0498ZM23.645 11.4078C23.449 10.6768 22.873 10.1008 22.142 9.9048C20.817 9.5498 15.5 9.5498 15.5 9.5498C15.5 9.5498 10.184 9.5498 8.859 9.9048C8.127 10.1008 7.551 10.6768 7.356 11.4078C7 12.7338 7 15.4998 7 15.4998C7 15.4998 7 18.2658 7.356 19.5918C7.551 20.3228 8.127 20.8998 8.859 21.0948C10.184 21.4498 15.5 21.4498 15.5 21.4498C15.5 21.4498 20.817 21.4498 22.142 21.0948C22.873 20.8998 23.449 20.3228 23.645 19.5918C24 18.2658 24 15.4998 24 15.4998C24 15.4998 24 12.7338 23.645 11.4078Z"
        fill="currentColor"
      />
    </svg>
  );
}
